import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PhxBadgeComponent } from './phx-badge.component';
import { PhxIconModule } from './../icon/icon.module';
import { PhxDividerModule } from '../divider/phx-divider.module';

@NgModule({
  declarations: [
    PhxBadgeComponent
  ],
  imports: [
    CommonModule,
    PhxIconModule,
    PhxDividerModule,
  ],
  exports: [
    PhxBadgeComponent
  ]
})
export class PhxBadgeModule { }
